import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetArrowUpArrowDown: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M8 3v18m0-18L5 6m3-3l3 3M16 21V3m0 18l3-3m-3 3l-3-3" />
      </svg>
    </div>
  );
};

export default WidgetArrowUpArrowDown;
